import { Badge, BlockStack, Box, Button, ButtonGroup, Card, InlineStack, Text } from '@shopify/polaris';
import { useEffect } from 'react';
import { useApprovalSummaryStore, useAuthStore } from '../../context/useStore.js';
import { CardHeading } from '../../shared/components/cards/CardHeading.jsx';
import { isAccountingRole } from '../../utils/userRoles.js';

// Homepage entry point to the approval queues: how many documents wait for me (and for accounting).
export default function ApprovalsHomeCard() {
  const { user } = useAuthStore();
  const summary = useApprovalSummaryStore((state) => state.summary);
  const refresh = useApprovalSummaryStore((state) => state.refresh);
  const accounting = isAccountingRole(user?.role);

  useEffect(() => {
    if (user?.id) refresh();
  }, [user?.id, refresh]);

  const mine = summary?.mine?.total || 0;
  const intake = summary?.intake;
  if (!mine && !accounting) return null;

  return (
    <Box paddingBlockEnd="300">
      <Card>
        <CardHeading title="Approvals" />
        <BlockStack gap="300">
          <InlineStack gap="400" blockAlign="center" wrap>
            <InlineStack gap="200" blockAlign="center">
              <Badge tone={mine ? 'attention' : 'success'}>{String(mine)}</Badge>
              <Text>{mine === 1 ? 'document is waiting for your approval' : 'documents are waiting for your approval'}</Text>
              {summary?.mine ? (
                <Text tone="subdued" variant="bodySm">
                  {`${summary.mine.invoices} invoice${summary.mine.invoices === 1 ? '' : 's'}, ${summary.mine.creditnotes} credit note${summary.mine.creditnotes === 1 ? '' : 's'}`}
                </Text>
              ) : null}
            </InlineStack>
            {accounting && intake ? (
              <InlineStack gap="200" blockAlign="center">
                <Badge tone={intake.total ? 'attention' : 'success'}>{String(intake.total)}</Badge>
                <Text>to process in intake</Text>
                <Text tone="subdued" variant="bodySm">
                  {`${intake.invoices.unprocessed + intake.creditnotes.unprocessed} new, ${intake.invoices.toAssign + intake.creditnotes.toAssign} to assign, ${
                    intake.invoices.rejected + intake.creditnotes.rejected
                  } rejected`}
                </Text>
              </InlineStack>
            ) : null}
          </InlineStack>
          <ButtonGroup>
            <Button variant="primary" url="/approvals" disabled={!mine}>
              Open my queue
            </Button>
            {accounting ? <Button url="/approvals/intake">Open intake</Button> : null}
          </ButtonGroup>
        </BlockStack>
      </Card>
    </Box>
  );
}
